import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';
const styles = cssMap({
	loadingIndicator: {
		paddingBlock: token('space.100'),
	},
});
export const LoadingIndicator = ({ label }: { label: string }): React.JSX.Element => {
	return (
		<Flex justifyContent="center" xcss={styles.loadingIndicator}>
			<Spinner size="small" label={label} interactionName={label} />
		</Flex>
	);
};
